<template>
  <div class="row">
    <div class="col-12">
      <table class="table" v-bind:class="{ keyFacts: blockData.key_fact }">
        <tbody>
          <tr v-for="(row, index) in blockData.rows">
            <td>{{ row.label }}</td>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
      <div class="table-footer" v-html="blockData.footer"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      blockData: Object
    }
  }
</script>